<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  
  <div class="fill-height wrapper d-flex justify-content-center">
    <div class="d-flex flex-column justify-content-center align-items-center login-panel">
      <div>
        <img src="../../assets/HOLCIM_SMARTFLOW_Logo_2025_White_sRGB.png" width="240"/>
      </div>
      <div style="margin-top: 40px;">
        <GoogleLogin :callback="callback" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { googleOneTap, decodeCredential } from "vue3-google-login";
import router from "../../router/router";
import { useStorage } from "vue3-storage";

const msg = ref('');
const isSignIn = ref(false);
const count = ref('');
const storage = useStorage();

// Check for existing session before mounting
const date = new Date();
const timestampInMs = date.getTime();
const unixTimestamp = Math.floor(timestampInMs / 1000);
const google_exp_date = storage.getStorageSync("exp_date");

if (google_exp_date && unixTimestamp < google_exp_date) {
  router.push('/PumpingCalculator');
  isSignIn.value = true;
} else {
  console.log("not connected");
  storage.clearStorageSync(); // Good practice to clear storage if token expired.
}

// Google One-Tap auto login on mount
onMounted(() => {
  if (isSignIn.value === false) {
    googleOneTap({ autoLogin: true })
      .then((response) => {
        console.log("Handle the response on googleOneTap", response);
        const userData = decodeCredential(response.credential);
        if (
          ["holcim.com", "lafargeholcim.com", "lafarge.com", "aggregate.com", "londonconcrete.com", "innocon.on.ca"].includes(userData.hd) && userData.email_verified === true
        ) {
          console.log("Handle the userData Good (OneTap)", userData);
          storage.setStorageSync("userData", userData);
          storage.setStorageSync("exp_date", userData.exp);
          storage.setStorageSync("is_logged", true);
          return router.push('/PumpingCalculator');
        } else {
          msg.value = "No valid email please use @holcim.com";
          console.log(msg.value);
          console.log("Bad data (OneTap)", userData);
        }
      })
      .catch((error) => {
        console.log("Handle the error (OneTap)", error);
      });
  }
});

// Callback for GoogleLogin button
const callback = (response) => {
  const userData = decodeCredential(response.credential);

  if (
    ["holcim.com", "lafargeholcim.com", "lafarge.com", "aggregate.com", "londonconcrete.com", "innocon.on.ca"].includes(userData.hd) && userData.email_verified === true
  ) {
    console.log("Handle the userData Good (Button)", userData);
    storage.setStorageSync("userData", userData);
    storage.setStorageSync("exp_date", userData.exp);
    storage.setStorageSync("is_logged", true);
    return router.push('/PumpingCalculator');
  } else {
    console.log("Bad data (Button)", userData);
    setTimeout(() => { count.value = ''; }, 8000);
    count.value = 'No valid email please login using @holcim account';
  }
};
</script>

<style scoped>
@import "./LoginScreen.css";
</style>
